import { memo } from "react";
import type { SectionRow } from "@/lib/categories.functions";
import { safeParseSection, type SectionTypeKey } from "./schemas";
import Hero from "./Hero";
import MediaTextSplit from "./MediaTextSplit";
import FullBleedMedia from "./FullBleedMedia";
import Gallery from "./Gallery";
import PullQuote from "./PullQuote";
import Stats from "./Stats";
import Cta from "./Cta";
import AccordionInline from "./AccordionInline";

function SectionRendererImpl({ section }: { section: SectionRow }) {
  const type = section.type as SectionTypeKey;
  const data = safeParseSection(type, section.data);
  switch (type) {
    case "hero":
      return <Hero {...(data as any)} />;
    case "media_text_split":
      return <MediaTextSplit {...(data as any)} />;
    case "full_bleed_media":
      return <FullBleedMedia {...(data as any)} />;
    case "gallery":
      return <Gallery {...(data as any)} />;
    case "pull_quote":
      return <PullQuote {...(data as any)} />;
    case "stats":
      return <Stats {...(data as any)} />;
    case "cta":
      return <Cta {...(data as any)} />;
    case "accordion_inline":
      return <AccordionInline {...(data as any)} />;
    default:
      return null;
  }
}

export const SectionRenderer = memo(SectionRendererImpl);
export default SectionRenderer;
